import { Truck, Users } from "lucide-react";

const OPTIONS = [
  { key: "ship", label: "Ship My Order", price: "$8 flat-rate shipping", icon: Truck },
  { key: "meetup", label: "Local Meetup", price: "Free", icon: Users },
];

export const DeliveryOptions = ({ value, onChange, meetupEnabled }) => (
  <div className={`grid gap-3 ${meetupEnabled ? "sm:grid-cols-2" : ""}`} role="radiogroup" aria-label="Delivery method" data-testid="delivery-options">
    {OPTIONS.filter((o) => o.key === "ship" || meetupEnabled).map(({ key, label, price, icon: Icon }) => {
      const active = value === key;
      return (
        <button
          type="button" key={key} role="radio" aria-checked={active} onClick={() => onChange(key)}
          data-testid={`delivery-${key}`}
          className={`flex items-start gap-3 text-left rounded-xl border p-4 transition-colors ${active ? "border-[#59394F] bg-[#59394F]/5 ring-1 ring-[#59394F]" : "border-[#A8B59A]/40 hover:bg-[#F4EBDD]"}`}
        >
          <Icon size={18} className={active ? "text-[#59394F] mt-0.5" : "text-[#5E6B51] mt-0.5"} />
          <span>
            <span className="block text-[15px] font-medium text-[#5A433B]">{label}</span>
            <span className="block text-xs text-[#5E4D5A] mt-0.5">{price}</span>
          </span>
        </button>
      );
    })}
  </div>
);

export const MEETUP_AREAS = ["Enterprise, AL", "Daleville, AL"];

export const MeetupArea = ({ value, onChange }) => (
  <div className="mt-4 rounded-xl bg-[#59394F]/5 p-4" data-testid="meetup-note">
    <p className="text-sm text-[#59394F]">Meetups are in Enterprise, AL or Daleville, AL. We'll text you to confirm a time and spot.</p>
    <p className="text-xs font-medium text-[#5A433B] mt-3 mb-2">Choose your meetup area</p>
    <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Meetup area">
      {MEETUP_AREAS.map((area) => (
        <button
          type="button" key={area} role="radio" aria-checked={value === area} onClick={() => onChange(area)}
          data-testid={`meetup-area-${area.split(",")[0].toLowerCase()}`}
          className={`rounded-full border px-4 py-1.5 text-sm transition-colors ${value === area ? "border-[#59394F] bg-[#59394F] text-white" : "border-[#A8B59A]/50 text-[#5A433B] hover:bg-[#F4EBDD]"}`}
        >{area}</button>
      ))}
    </div>
  </div>
);

